import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
 selector: 'formly-field-textarea',
 template: `
    <ion-item>
        <ion-label position="floating">{{ field.templateOptions.label }}</ion-label>
        <ion-textarea [formControl]="formControl" [formlyAttributes]="field"></ion-textarea>
    </ion-item>
 `,
})
export class FormlyFieldIonTextarea extends FieldType {

}
